import { ourJourney } from "@/data/aboutUs";
import { motion } from "framer-motion";
import LucideIcon from "utils/LucideIcon";

const SectionOurJourney = () => {
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut" as const,
      },
    },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  return (
    <>
      <section id="ourJourney" className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={containerVariants}
            className="text-center md:text-start mb-20"
          >
            <motion.h2
              variants={itemVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
            >
              <div className="flex items-center md:text-left justify-center md:justify-start mb-4">
                <LucideIcon
                  name="Route"
                  className="w-10 h-10 text-blue-900 hover:text-blue-900 hidden md:inline-block mr-3"
                />
                <h2 className="text-4xl md:text-5xl font-bold font-inter text-secondary-gradient bg-clip-text text-transparent pb-1">
                  Our Journey
                </h2>
              </div>
            </motion.h2>
            <motion.div
              className="w-24 h-1 bg-secondary-gradient mx-auto md:mx-0 md:ml-14 mb-8 rounded-xl"
              initial={{ width: 0 }}
              whileInView={{ width: 96 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              viewport={{ amount: 0.2 }}
            ></motion.div>
            <motion.p
              className="text-xl text-gray-600 max-w-3xl leading-relaxed font-inter"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              Key milestones that shaped our company and defined our{" "}
              <br className="hidden md:inline-block" />
              path to excellence
            </motion.p>
          </motion.div>

          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-secondary-gradient"></div>
            {ourJourney.map((item, index) => {
              const isEven = index % 2 === 0;
              const flexDirection = isEven
                ? "md:flex-row"
                : "md:flex-row-reverse";
              const paddingClass = isEven ? "md:pr-8" : "md:pl-8";
              const contentDirection = isEven && "md:text-right";
              const justifyContent = isEven
                ? "md:justify-end"
                : "md:justify-start";
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.03 }}
                  className={`relative flex flex-col md:flex-row ${flexDirection} ${contentDirection} items-start md:items-center mb-12`}
                >
                  <div
                    className={`md:w-1/2  ${paddingClass} ${contentDirection}`}
                  >
                    <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
                      <div
                        className={`flex items-center justify-center mb-4 ${justifyContent}`}
                      >
                        <LucideIcon
                          name="Calendar"
                          className="w-6 h-6 text-blue-600 mr-3"
                        />
                        <span className="text-sm font-medium text-blue-600 bg-blue-100 px-3 py-1 rounded-full font-inter">
                          {item.date}
                        </span>
                      </div>
                      <h3 className="text-xl font-bold mb-2 font-inter">
                        {item.event}
                      </h3>
                      <p className="font-inter text-sm">{item.info}</p>
                    </div>
                  </div>

                  <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-blue-600 rounded-full border-4 border-white"></div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionOurJourney;
